export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
export const cognitoConfig = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
  loginUrl: process.env.REACT_APP_AWS_COGNITO_LOGIN_URL,
};
export const auth0Config = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};
export const mapConfig = process.env.REACT_APP_MAP_MAPBOX;
export const googleAnalyticsConfig: string =
  process.env.REACT_APP_GOOGLE_ANALYTICS_TRAKING_ID || "null";
export const apiConfig = {
  API_URL: process.env.REACT_APP_NANGMAN_SERVER_API_URL,
};
export const s3Config = {
  ASSET_URL: process.env.REACT_APP_NANGMAN_S3_ASSET_URL,
  EXE_URL: process.env.REACT_APP_NANGMAN_TOORDER_EXE_URL,
};

export const cfConfig = {
  ASSET_URL: process.env.REACT_APP_NANGMAN_CF_ASSET_URL,
};
